import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    assetsLabel: 'Select your personal estate range in €',
    buttonLabelNo: 'No',
    buttonLabelYes: 'Yes',
    headerDescription:
      'Because Shine is a regulated financial institution, we’re required to ask these questions before opening your account. This information is secure and strictly confidential.',
    incomeLabel: 'Select your income range in €',
    linkLabelKnowMore: 'I want to know more',
    nextButtonLabel: 'Confirm my information',
    no: 'No',
    sectionLabelFiscalResidence:
      'Do you have tax residency **in any country other than France**?',
    sectionLabelUsCitizen:
      'Are you a citizen or tax payer in the United States? (US Person)',
    title: 'Tell us your financial situation',
    yes: 'Yes',
  },
  fr: {
    assetsLabel: 'Votre patrimoine personnel en €',
    buttonLabelNo: 'Non',
    buttonLabelYes: 'Oui',
    headerDescription:
      'Shine est un établissement financier. La régulation bancaire nous impose de vous poser quelques questions avant d’ouvrir votre compte. Ces informations sont strictement confidentielles et sécurisées.',
    incomeLabel: 'Votre revenu annuel en €',
    linkLabelKnowMore: 'En savoir plus',
    nextButtonLabel: 'Confirmer mes informations',
    no: 'Non',
    sectionLabelFiscalResidence:
      'Avez-vous une résidence fiscale **dans un autre pays que la France**\u00A0?',
    sectionLabelUsCitizen:
      'Avez-vous la citoyenneté américaine ou payez-vous des impôts aux États-Unis (US person)\u00A0?',
    title: 'Indiquez votre situation fiscale',
    yes: 'Oui',
  },
} as const);
